import styled from 'styled-components';

export const CompanyInfoContainer = styled.section`
  width: 100%;
  max-width: 820px;

  display: flex;
  flex-direction: column;
  gap: var(--space-l);

  margin: 0 auto;
`;

export const CompanyInfoHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  gap: var(--space-m);

  padding-bottom: var(--space-l);

  border-bottom: 1px solid var(--grey1);

  @media screen and (max-width: 600px) {
    gap: var(--space-s);
    padding-bottom: var(--space-m);
  }
`;

export const CompanyInfoHeaderIcon = styled.div`
  width: 46px;
  height: 46px;
  min-width: 46px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(234, 154, 38, 0.1);
  color: var(--orange4);

  border-radius: 12px;

  svg {
    font-size: 1rem;
  }

  @media screen and (max-width: 600px) {
    width: 40px;
    height: 40px;
    min-width: 40px;

    border-radius: 10px;

    svg {
      font-size: 0.9rem;
    }
  }
`;

export const CompanyInfoHeaderContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  > span {
    color: var(--orange4);

    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.07em;
    line-height: 1.2;
    text-transform: uppercase;
  }

  h2 {
    margin: 0;

    color: var(--grey7);

    font-size: clamp(1.35rem, 2vw, 1.7rem);
    font-weight: 800;
    letter-spacing: -0.025em;
    line-height: 1.25;
  }

  p {
    max-width: 620px;

    margin: 0.15rem 0 0;

    color: var(--grey4);

    font-size: 0.85rem;
    line-height: 1.55;
  }

  @media screen and (max-width: 600px) {
    h2 {
      font-size: 1.2rem;
    }

    p {
      font-size: 0.78rem;
    }
  }
`;

export const CompanyInfoFields = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: var(--space-m);
`;

export const CompanyInfoFieldRow = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-m);

  > * {
    min-width: 0;
  }

  @media screen and (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`;

export const CompanyContactSection = styled.section`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: var(--space-m);

  margin-top: var(--space-s);
  padding: var(--space-l);

  background: var(--grey0);

  border: 1px solid var(--grey1);
  border-radius: 14px;

  > p {
    max-width: 650px;

    margin: calc(var(--space-xs) * -1) 0 0;

    color: var(--grey4);

    font-size: 0.78rem;
    line-height: 1.55;
  }

  @media screen and (max-width: 600px) {
    gap: var(--space-s);

    padding: var(--space-m);

    > p {
      margin-top: 0;

      font-size: 0.73rem;
    }
  }
`;

export const CompanyContactHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-m);

  > div:first-child {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;

    > span {
      color: var(--orange4);

      font-size: 0.65rem;
      font-weight: 800;
      letter-spacing: 0.06em;
      line-height: 1.2;
      text-transform: uppercase;
    }

    h3 {
      margin: 0;

      color: var(--grey7);

      font-size: 0.95rem;
      font-weight: 750;
      line-height: 1.35;
    }
  }

  @media screen and (max-width: 500px) {
    flex-direction: column;

    gap: var(--space-xs);
  }
`;

export const CompanyContactOptional = styled.span`
  flex: 0 0 auto;

  padding: 0.35rem 0.6rem;

  background: var(--white);
  color: var(--grey4);

  border: 1px solid var(--grey1);
  border-radius: 100px;

  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1.2;
`;

export const CompanyInfoActions = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-m);

  margin-top: var(--space-s);
  padding-top: var(--space-m);

  border-top: 1px solid var(--grey1);

  > button,
  > div,
  > a {
    margin: 0;
  }

  .backButton {
    padding: var(--space-s) var(--space-m);

    background: transparent;
    color: var(--grey5);

    border: 1px solid var(--grey2);
    border-radius: var(--borderRadiusSmall);

    font: inherit;
    font-size: 0.85rem;
    font-weight: 700;

    cursor: pointer;

    transition:
      background 0.2s ease,
      border-color 0.2s ease,
      color 0.2s ease;

    &:hover {
      background: var(--grey0);
      color: var(--grey7);
      border-color: var(--grey3);
    }
  }

  @media screen and (max-width: 600px) {
    flex-direction: column-reverse;
    align-items: stretch;

    gap: var(--space-s);

    .backButton {
      width: 100%;
    }

    > div,
    > a {
      width: 100%;
    }

    button,
    a {
      width: 100%;
    }
  }
`;
